const d = (f, r) => r <= 7 ? Array.from({ length: r }, (n, i) => i + 1) : f <= 4 ? [1, 2, 3, 4, 5, "...", r] : f >= r - 3 ? [
  1,
  "...",
  r - 4,
  r - 3,
  r - 2,
  r - 1,
  r
] : [
  1,
  "...",
  f - 1,
  f,
  f + 1,
  "...",
  r
];
export {
  d as getRenderedPages
};
//# sourceMappingURL=tools.js.map
